import React from "react"
import Auth from "@aws-amplify/auth"
import {
  ButtonGoogle,
  ButtonGoogleSmall,
} from "@thedgbrt/logology-ui-components"

const SignUpWithGoogle = ({ small }) => {
  if (small === true) {
    return (
      <ButtonGoogleSmall
        onClick={() => Auth.federatedSignIn({ provider: "Google" })}
      >
        Continue with Google
      </ButtonGoogleSmall>
    )
  }

  return (
    <ButtonGoogle
      onClick={() => Auth.federatedSignIn({ provider: "Google" })}
      style={{ width: "100%" }}
    >
      Continue with Google
    </ButtonGoogle>
  )
}

export default SignUpWithGoogle
